var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesBuild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 369,
    viewBox: "0 0 376 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5423_2226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46875 94.5332V453.307L187.991 547.711V188.95L1.46875 94.5332Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.992 547.711L374.529 453.307V94.5332L187.992 188.95V547.711Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46875 94.5332L185.698 1.28906L374.528 94.5332L187.991 188.95L1.46875 94.5332Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7695 94.533L187.993 19.0098L337.217 94.533L187.993 170.069L38.7695 94.533Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.993 37.8906V19.0098L38.7695 94.533L57.2498 104.07L187.993 37.8906Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.216 94.533L187.992 19.0098V37.8906L318.559 103.98L337.216 94.533Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 141.742V160.623L38.767 170.07V151.189L20.125 141.742Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0742 155.906V174.787L67.7309 184.234V165.353L49.0742 155.906Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0234 170.068V188.949L96.6801 198.396V179.502L78.0234 170.068Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.973 184.232V203.113L125.629 212.547V193.666L106.973 184.232Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.918 198.396V217.277L154.575 226.711V207.83L135.918 198.396Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 180.096V198.977L38.767 208.423V189.543L20.125 180.096Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0742 194.26V213.141L67.7309 222.587V203.707L49.0742 194.26Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0234 208.424V227.305L96.6801 236.751V217.871L78.0234 208.424Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.973 222.588V241.469L125.629 250.903V232.022L106.973 222.588Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.918 236.752V255.633L154.575 265.067V246.186L135.918 236.752Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 218.451V237.332L38.767 246.779V227.898L20.125 218.451Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0742 232.613V251.494L67.7309 260.941V242.06L49.0742 232.613Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0234 246.777V265.658L96.6801 275.105V256.224L78.0234 246.777Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.973 260.941V279.822L125.629 289.269V270.375L106.973 260.941Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.918 275.105V293.986L154.575 303.42V284.539L135.918 275.105Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 256.805V275.686L38.767 285.132V266.252L20.125 256.805Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0742 270.969V289.85L67.7309 299.296V280.416L49.0742 270.969Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0234 285.133V304.014L96.6801 313.46V294.58L78.0234 285.133Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.973 299.297V318.178L125.629 327.625V308.731L106.973 299.297Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.918 313.461V332.342L154.575 341.776V322.895L135.918 313.461Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 295.16V314.041L38.767 323.488V304.607L20.125 295.16Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0742 309.322V328.203L67.7309 337.65V318.769L49.0742 309.322Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0234 323.486V342.367L96.6801 351.814V332.933L78.0234 323.486Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.973 337.65V356.531L125.629 365.978V347.084L106.973 337.65Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.918 351.814V370.695L154.575 380.129V361.248L135.918 351.814Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.504 143.404V162.285L334.848 171.719V152.838L353.504 143.404Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.544 157.568V176.449L305.902 185.883V167.002L324.544 157.568Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.594 171.719V190.612L276.938 200.046V181.166L295.594 171.719Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.649 185.883V204.764L247.992 214.21V195.33L266.649 185.883Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7 200.047V218.928L219.043 228.375V209.494L237.7 200.047Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.504 181.758V200.639L334.848 210.085V191.192L353.504 181.758Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.544 195.922V214.803L305.902 224.237V205.356L324.544 195.922Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.594 210.086V228.967L276.938 238.401V219.52L295.594 210.086Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.649 224.236V243.117L247.992 252.564V233.683L266.649 224.236Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7 238.4V257.281L219.043 266.728V247.847L237.7 238.4Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.504 220.113V238.994L334.848 248.441V229.547L353.504 220.113Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.544 234.277V253.158L305.902 262.592V243.711L324.544 234.277Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.594 248.441V267.322L276.938 276.756V257.875L295.594 248.441Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.649 262.592V281.486L247.992 290.919V272.039L266.649 262.592Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7 276.756V295.637L219.043 305.084V286.203L237.7 276.756Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.504 258.467V277.348L334.848 286.794V267.901L353.504 258.467Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.544 272.631V291.512L305.902 300.946V282.065L324.544 272.631Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.594 286.795V305.676L276.938 315.11V296.229L295.594 286.795Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.649 300.945V319.839L247.992 329.273V310.392L266.649 300.945Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7 315.109V333.99L219.043 343.437V324.556L237.7 315.109Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.504 296.822V315.703L334.848 325.15V306.256L353.504 296.822Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.544 310.986V329.867L305.902 339.301V320.42L324.544 310.986Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.594 325.15V344.031L276.938 353.465V334.584L295.594 325.15Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.649 339.301V358.194L247.992 367.628V348.748L266.649 339.301Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7 353.465V372.346L219.043 381.792V362.912L237.7 353.465Z",
    stroke: "#4E4EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5423_2226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 549,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBuild);
export default __webpack_public_path__ + "static/media/services_build.151a1fe2ea9f367a68090014728de6bb.svg";
export { ForwardRef as ReactComponent };